<template>
  <div class="status-progress">
    <div :class="clsx('status-progress--account-type', { 'status-progress--active': isAccountTypeStep })"></div>
    <div :class="clsx('status-progress--personal-data', { 'status-progress--active': isPersonalDataStep })"></div>
    <div :class="clsx('status-progress--credentials', { 'status-progress--active': isCredentialDataStep })"></div>
    <div :class="clsx('status-progress--setup-password', { 'status-progress--active': isSetupPasswordStep })"></div>
  </div>
</template>

<script>
import { clsx } from 'clsx';

export default {
  props: {
    currentStep: {
      type: String,
      required: true,
      validator: (value) => [
        'account-type', 'personal-data', 'organization-data', 'personal-credential-data',
        'organization-credential-data', 'confirmation-letter', 'setup-password',
      ].includes(value),
    },
  },
  computed: {
    isAccountTypeStep() {
      return [
        'account-type', 'personal-data', 'organization-data', 'personal-credential-data',
        'organization-credential-data', 'confirmation-letter', 'setup-password',
      ].includes(this.currentStep);
    },
    isPersonalDataStep() {
      return [
        'personal-data', 'organization-data', 'personal-credential-data', 'organization-credential-data',
        'confirmation-letter', 'setup-password',
      ].includes(this.currentStep);
    },
    isCredentialDataStep() {
      return [
        'personal-credential-data', 'organization-credential-data', 'confirmation-letter', 'setup-password',
      ].includes(this.currentStep);
    },
    isSetupPasswordStep() {
      return ['confirmation-letter', 'setup-password'].includes(this.currentStep);
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.status-progress {
  display: flex;
  align-items: center;
  justify-content: center;

  &--account-type, &--personal-data, &--credentials, &--setup-password {
    width: 116px;
    height: 8px;
    background-color: #CADDFC;
    border-radius: 4px;
    margin: 16px 4px;
  }

  &--active {
    background-color: #EB883B;
  }
}
</style>
